import { z } from 'zod'

export const internalEmailSearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z.enum(['email', 'subject', 'date']).catch('date'),
  direction: z.enum(['asc', 'desc']).catch('desc'),
})

export type InternalEmailSearch = z.infer<typeof internalEmailSearchSchema>

export const defaultInternalEmailSearch: InternalEmailSearch = {
  page: 1,
  pageSize: 10,
  sortBy: 'date',
  direction: 'desc',
}
